export const MEMBERSHIP_DISCOUNT_ID = 'MEMBER_DISCOUNT';
